module.exports = __webpack_public_path__ + "static/img/04.50b4ccb0.png";